import { useCallback, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { QuickGroupSurvey } from 'features/subscription-process/profiling-process/components/Survey/QuickGroupSurvey';
import { selectAnswers, selectVisibleSteps } from '../../../slices/genericSelectors';
import { goToFirstStep } from '../../../slices/genericProfilingSlice';
import {
  BorrowerInsuredFormFieldNames,
  BorrowerInsuredFormValues
} from '../borrowerInsuredForm';
import { PossibleAnswer } from '../../../types/interfaces';

export const BorrowerSurveyLayout = () => {
  const { setFieldValue } = useFormikContext<BorrowerInsuredFormValues>();
  const dispatch = useAppDispatch();
  const visibleSteps = useAppSelector(selectVisibleSteps);
  const existingAnswers = useAppSelector(selectAnswers);

  useEffect(() => {
    dispatch(goToFirstStep());
  }, [dispatch]);

  const handleChange = useCallback(
    (answers: Record<string, PossibleAnswer[]>) => {
      const formatted: Record<string, any> = {};
      Object.entries(answers).forEach(([key, values]) => {
        formatted[key] = values && values.length > 0 ? values : null;
      });
      setFieldValue(BorrowerInsuredFormFieldNames.SurveyForm, formatted);
    },
    [setFieldValue]
  );

  return (
    <div className="relative mt-4">
      <QuickGroupSurvey
        groups={visibleSteps}
        existingAnswers={existingAnswers}
        onChange={handleChange}
      />
    </div>
  );
};
